export default __webpack_public_path__ + "static/media/section2-3-img2.7acca732.png";